<template>
  <!-- Only in the Website Studio: a data section with nothing to show yet
       says what to add (live sites leave the section out instead). -->
  <p v-if="inStudio" class="s2-studio-gap"><slot></slot></p>
</template>

<script setup>
import {computed} from "vue";
import {studioMode} from "@/classes/previewBridge.js";

const inStudio = computed(() => studioMode.value !== "off");
</script>
